import React from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/WithRouter';
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

import ToggleButton from '../../components/ToggleButton';

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginType: 'legal',
      enableViewPassword: true,
      doc: '',
      password: '',
      open: false,
      step: 0,
      userName: 'User',
      userPhone: '(+55 11) 99999-9999',
      time: 0,
      redefineRetypePassword: '',
      redefinePassword: '',
      enableViewRedefineRetypePassword: true,
      enableViewRedefinePassword: true,
      widthScreen: window.screen.width,
    };
  }

  handleClickLogin() {
    localStorage.setItem('emailUser', 'user@higherbank.com');
    localStorage.setItem('nameUser', 'Usuário 1');
    localStorage.setItem('fantasyName', 'Higher Bank');
    window.location.href = '/user';
  };

  maskDoc(event, that) {
      var value = event.target.value;
      this.setState({doc: value});
  }

  maskCNPJ(event, that) {
      var value = event.target.value;
      this.setState({doc: value});
  }

  maskPassword(event, that) {
      this.setState({password: event.target.value});
  }

  maskRedefinePassword(event, that) {
      this.setState({redefinePassword: event.target.value});
      this.checkPasswordStrength(event.target.value);
  }

  maskRedefineRetypePassword(event, that) {
      this.setState({redefineRetypePassword: event.target.value});
  }

  enterEvent(event, that) {
      if(event.key === 'Enter')
       return that.handleClickLogin();
  }

  recoveryPassword(){
    this.setState({open: true, step: 1});
  }

  setOpen(that, value){
    if(value)
      that.setState({open: value, time: 0, step: 1});
    else{
      that.setState({open: value, time: 0}, ()=> {
        setTimeout(
          () => that.setState({step: 0}),
          200
        );
      });
    }
  }

  sendResetByEmail(){
    if(this.state.time < 1){
      this.setState({step: 2});
      let that = this;
      this.setState({time: 25}, () => {
        that.startTime()
      });
    }
  }

  sendResetByCode(){
    this.setState({step: 3});
  }

  startTime(){
    if(this.state.time > 0){
      let that = this;
      setTimeout(function() {
        that.setState({ time: that.state.time-1 });
        that.startTime();
      }, 1000);
    }
  }

  formatTime(time){
    if(time > 9){
      return time;
    }
    else if(time >= 0){
      return '0' + time;
    }
    else{
      return '00';
    }
  }

  redefinePassword(){
    this.setState({step: 4});
  }

  checkPasswordStrength(password) {
    let strength = 0;

    if (password.length > 8)
      strength += 1;
    if (password.match(/[a-z]/) && password.match(/[A-Z]/))
      strength += 1;
    if (password.match(/\d/))
      strength += 1;
    if (password.match(/[^a-zA-Z\d]/))
      strength += 1;

    if (strength < 2) {
      document.getElementById("labelStatusStrongPassword").innerHTML = "Fraca";
      document.getElementById("statusStrongPassword").style.backgroundColor = "red";
      document.getElementById("statusStrongPassword").style.width = "10%";
    } else if (strength === 2) {
      document.getElementById("labelStatusStrongPassword").innerHTML = "Média";
      document.getElementById("statusStrongPassword").style.backgroundColor = "yellow";
      document.getElementById("statusStrongPassword").style.width = "50%";
    } else {
      document.getElementById("labelStatusStrongPassword").innerHTML = "Difícil";
      document.getElementById("statusStrongPassword").style.backgroundColor = "green";
      document.getElementById("statusStrongPassword").style.width = "90%";
    }
  }

  render() {
    return (
      <section id="loginPage">
          <div className="textContent" style={{minHeight: "80vh"}}>
            <br/><br/>

            <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Higher" className="iconHigherImage"/>
            <div className="title">BackOffice Higher</div>

            <div>
              <div className="contentInput">
                <p className="label">Digite seu email</p>
                <input className="input" type="email" onKeyPress={(e) => this.enterEvent(e, this)} onChange={(e) => this.maskDoc(e, this)} value={this.state.doc}></input>

                <p className="label">Digite sua senha</p>
                <div className="contentIconPasswordInput">
                  {
                    this.state.enableViewPassword &&
                    <img src={require("../../assets/imgs/open-eye.svg").default} alt="ícone visualizar senha" className="iconPasswordInput" onClick={() => {this.setState({enableViewPassword: !this.state.enableViewPassword})}} />
                  }
                  {
                    !this.state.enableViewPassword &&
                    <img src={require("../../assets/imgs/close-eye.svg").default} style={{border: "3px solid rgba(0,0,0,0)"}} alt="ícone visualizar senha" className="iconPasswordInput" onClick={() => {this.setState({enableViewPassword: !this.state.enableViewPassword})}} />
                  }
                </div>
                <input className="input" type={(this.state.enableViewPassword?'text':'password')} onKeyPress={(e) => this.enterEvent(e, this)} onChange={(e) => this.maskPassword(e, this)} value={this.state.password}></input>
              </div>
            </div><br/>
            <p className="recoveryPassword" onClick={() => {this.recoveryPassword();}}>Esqueci minha senha</p>
            <br/><br/>
            <div className="">
             <ToggleButton onChange={state => {
               this.setState({timerOn: state});
             }} defaultChecked={true} />
             <p className="labelQuote" style={{display: "inline-block", position: "relative", top: "-2px", fontWeight: "bold", fontSize: "16px"}}>&nbsp;&nbsp;Manter-me logado neste dispositivo</p>
            </div>

            <div className="btnLogin" onClick={() => {this.handleClickLogin();}}>Login</div>

            {
              this.state.widthScreen < 721 &&
              <span>
                {
                  this.state.step > 0 &&
                  <span style={{backgroundColor: "#fff", position: "absolute", left: "0px", top: "0px", width: "100%", height: "100%", padding: "10px"}}>
                  {
                    this.state.step === 1 &&
                    <div style={{width: "90%", height: "100%", display: "block", margin: "0px auto", position: "relative"}}>
                      <div className="logoLeft">
                        <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Higher" className="iconHigherImage"/>
                        BackOffice Higher
                      </div>
                      <br/>
                      <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px", cursor: "pointer"}} onClick={()=>{this.setState({step: 0})}}>
                        <b>voltar ao login</b>
                      </div>
                      <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                        <b style={{fontSize: "20px"}}>Esqueceu sua senha?<br/></b>
                        Iremos Ajudá-lo a redefini-la.
                      </div>
                      <div className="mt-2">
                        <p className="label" style={{marginBottom: "10px", fontSize: "15px"}}>Digite seu email</p>
                        <input
                          className="input"
                          type="email"
                          style={{
                            color: "#061B2B",
                            fontWeight: "bold",
                            fontSize: "14px",
                            textAlign: "left",
                            border: "1px solid #EBEBED",
                            borderRadius: "4px",
                            width: "90%",
                            height: "35px",
                            paddingLeft: "10px",
                            backgroundColor: "#EBEBED"
                          }}
                          onKeyPress={(e) => this.enterEvent(e, this)}
                          onChange={(e) => this.maskDoc(e, this)}
                          value={this.state.doc}></input>
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "290px",
                            backgroundColor: "#54E046",
                            color: "#fff",
                            borderRadius: "6px",
                            border: "2px solid #54E046",
                            height: "50px",
                            fontWeight: "bolder",
                            cursor: "pointer",
                            paddingTop: "10px",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                          className="btnLogin"
                          onClick={() => {this.sendResetByEmail();}}
                          >
                            Enviar código de redefinição
                          </div>
                      </div>
                    </div>
                  }
                  {
                    this.state.step === 2 &&
                    <div style={{width: "90%", height: "100%", display: "block", margin: "0px auto", position: "relative"}}>
                      <div className="logoLeft">
                        <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Higher" className="iconHigherImage"/>
                        higher
                      </div>
                      <br/>
                      <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px", cursor: "pointer"}} onClick={()=>{this.setState({step: 0})}}>
                        <b>voltar ao login</b>
                      </div>
                      <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                        <b style={{fontSize: "20px"}}>Olá, {this.state.userName}!<br/></b>
                        Digite o código de redefinição enviado no seu email
                      </div>
                      <div className="mt-2">

                        <input
                          className="input"
                          type="email"
                          style={{
                            color: "#061B2B",
                            fontWeight: "bold",
                            fontSize: "14px",
                            textAlign: "left",
                            border: "1px solid #EBEBED",
                            borderRadius: "4px",
                            width: "90%",
                            height: "35px",
                            paddingLeft: "10px",
                            backgroundColor: "#EBEBED"
                          }}
                          onKeyPress={(e) => this.enterEvent(e, this)}
                          onChange={(e) => this.maskDoc(e, this)}
                          value={this.state.doc}></input>

                        <div
                          style={{
                            width: "100%",
                            maxWidth: "290px",
                            backgroundColor: "#54E046",
                            color: "#fff",
                            borderRadius: "6px",
                            border: "2px solid #54E046",
                            height: "50px",
                            fontWeight: "bolder",
                            cursor: "pointer",
                            paddingTop: "10px",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                          className="btnLogin"
                          onClick={() => {this.sendResetByCode();}}
                          >
                          Redefinir senha
                        </div><br/>

                        <p style={{fontSize: "13px"}}><b>
                          Não recebeu?<br/>
                          <span
                            style={{
                              textDecoration: "underline",
                              color: "#54E046",
                              cursor: "pointer"
                            }}
                            onClick={() => {this.sendResetByEmail();}}
                            >
                            Enviar novamente
                          </span> em 00:{this.formatTime(this.state.time)} segundo

                        </b></p>
                      </div>
                    </div>
                  }
                  {
                    this.state.step === 3 &&
                    <div style={{width: "90%", height: "100%", display: "block", margin: "0px auto", position: "relative"}}>
                      <div className="logoLeft">
                        <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Higher" className="iconHigherImage"/>
                        higher
                      </div>
                      <br/>
                      <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                        <b style={{fontSize: "20px"}}>Redefina sua senha</b>
                      </div>

                      <div className="mt-2">
                        <div
                          style={{
                            backgroundColor: "#E2ECFB",
                            borderRadius: "8px",
                            fontSize: "12px",
                            color: "#236AD5",
                            padding: "10px"
                          }}
                        >
                          Para a sua segurança, nós recomendamos que a senha consista de pelo menos 8 caracteres, incluindo caracteres especiais (@, + , etc.), letras maiúsculas, minúsculas e números.
                        </div><br/>

                        <div className="label" style={{fontSize: "14px", position: "relative", marginBottom: "5px"}}>
                          Digite sua nova senha
                          <div className="contentStrongPassword" style={{
                            position: "absolute",
                            top: "-10px",
                            right: "0px"
                          }}>
                            <p id="labelStatusStrongPassword" style={{
                              textAlign: "right",
                              fontWeight: "bold"
                            }}>Fraca</p>
                            <div className="contentStatusStrongPassword" style={{
                              width: "100px",
                              position: "relative",
                              height: "5px",
                              backgroundColor: "#EBEBED",
                              borderRadius: "8px",
                              overflow: "hidden"
                            }}>
                              <div id="statusStrongPassword" style={{
                                position: "absolute",
                                left: "0px",
                                top: "0px",
                                backgroundColor: "red",
                                width: "10%",
                                height: "5px",
                                borderRadius: "8px"
                              }}></div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "295px"
                          }}>
                          {
                            this.state.enableViewRedefinePassword &&
                            <img
                              src={require("../../assets/imgs/open-eye.svg").default}
                              alt="Icone visualizar senha"
                              className="iconPasswordInput"
                              style={{
                                cursor: "pointer"
                              }}
                              onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                            />
                          }
                          {
                            !this.state.enableViewRedefinePassword &&
                            <img
                              src={require("../../assets/imgs/close-eye.svg").default}
                              alt="Icone visualizar senha"
                              className="iconPasswordInput"
                              style={{
                                cursor: "pointer",
                                border: "2px solid rgba(0,0,0,0)",
                                position: "relative",
                                top: "2px"
                              }}
                              onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                            />
                          }
                        </div>
                        <input
                          className="input"
                          type={(this.state.enableViewRedefinePassword?'text':'password')}
                          onKeyPress={(e) => this.enterEvent(e, this)}
                          onChange={(e) => this.maskRedefinePassword(e, this)}
                          style={{
                            color: "#061B2B",
                            fontWeight: "bold",
                            fontSize: "14px",
                            textAlign: "left",
                            border: "1px solid #EBEBED",
                            borderRadius: "4px",
                            width: "100%",
                            height: "35px",
                            paddingLeft: "10px",
                            backgroundColor: "#EBEBED"
                          }}
                          value={this.state.redefinePassword}></input>
                        <br/>
                        <p className="label" style={{fontSize: "14px", position: "relative", marginBottom: "5px"}}>Redigite sua nova senha</p>
                        <div
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "382px"
                          }}>
                          {
                            this.state.enableViewRedefineRetypePassword &&
                            <img
                              src={require("../../assets/imgs/open-eye.svg").default}
                              alt="Icone visualizar senha"
                              className="iconPasswordInput"
                              style={{
                                cursor: "pointer"
                              }}
                              onClick={() => {this.setState({enableViewRedefineRetypePassword: !this.state.enableViewRedefineRetypePassword})}} />
                          }
                          {
                            !this.state.enableViewRedefineRetypePassword &&
                            <img
                              src={require("../../assets/imgs/close-eye.svg").default}
                              alt="Icone visualizar senha"
                              className="iconPasswordInput"
                              style={{
                                cursor: "pointer",
                                border: "2px solid rgba(0,0,0,0)",
                                position: "relative",
                                top: "2px"
                              }}
                              onClick={() => {this.setState({enableViewRedefineRetypePassword: !this.state.enableViewRedefineRetypePassword})}} />
                          }
                        </div>
                        <input
                          className="input"
                          type={(this.state.enableViewRedefineRetypePassword?'text':'password')}
                          onKeyPress={(e) => this.enterEvent(e, this)}
                          onChange={(e) => this.maskRedefineRetypePassword(e, this)}
                          style={{
                            color: "#061B2B",
                            fontWeight: "bold",
                            fontSize: "14px",
                            textAlign: "left",
                            border: "1px solid #EBEBED",
                            borderRadius: "4px",
                            width: "100%",
                            height: "35px",
                            paddingLeft: "10px",
                            backgroundColor: "#EBEBED"
                          }}
                          value={this.state.redefineRetypePassword}></input>
                        <br/>
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "290px",
                            backgroundColor: "#54E046",
                            color: "#fff",
                            borderRadius: "6px",
                            border: "2px solid #54E046",
                            height: "50px",
                            fontWeight: "bolder",
                            cursor: "pointer",
                            paddingTop: "10px",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                          className="btnLogin"
                          onClick={() => {this.redefinePassword();}}
                          >
                          Redefinir senha
                        </div>
                      </div>
                    </div>
                  }
                  {
                    this.state.step === 4 &&
                    <div style={{width: "90%", height: "100%", display: "block", margin: "0px auto", position: "relative"}}>
                      <div className="logoLeft">
                        <img src={require("../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Higher" className="iconHigherImage"/>
                        higher
                      </div>
                      <br/>
                      <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                        <b style={{fontSize: "20px", marginBottom: "25px"}}>
                          <img
                            src={require("../../assets/imgs/check-clear.svg").default}
                            alt="Icone check"
                            className="iconPasswordInput"
                            style={{
                              display: "inline-block",
                              marginRight: "5px",
                              position: "relative",
                              top: "-3px"
                            }}
                            />
                          Senha redefinida com sucesso.
                        <br/></b>
                        {this.state.userName}, agora você pode fechar esse diálogo e acessar sua conta.
                      </div>
                      <div className="mt-2">
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "290px",
                            backgroundColor: "#54E046",
                            color: "#fff",
                            borderRadius: "6px",
                            border: "2px solid #54E046",
                            height: "50px",
                            fontWeight: "bolder",
                            cursor: "pointer",
                            paddingTop: "10px",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                          onClick={() => this.setOpen(this, false)}>
                          Ir
                        </div>
                      </div>
                    </div>
                  }
                </span>
              }
              </span>
            }
          </div>


        {
          this.state.widthScreen >= 721 &&
          <Transition.Root show={this.state.open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={()=>this.setOpen(this, false)}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                      <div className="closeModal" style={{width: "fit-content", position: "absolute", right: "10px", top: "5px", cursor: "pointer"}} onClick={() => this.setOpen(this, false)}>
                        <b>Fechar&nbsp;</b>
                        <img src={require("../../assets/imgs/bt-close.svg").default} alt="Close" className="iconClose" style={{display: "inline-block", position: "relative", top: "-2px"}}/>
                      </div>
                      {
                        this.state.step === 1 &&
                        <div style={{width: "100%", maxWidth: "300px", display: "block", margin: "10px auto"}}>
                          <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                            <b style={{fontSize: "20px"}}>Esqueceu sua senha?<br/></b>
                            Iremos Ajudá-lo a redefini-la.
                          </div>
                          <div className="mt-2">
                            <p className="label" style={{marginBottom: "10px", fontSize: "15px"}}>Digite seu email</p>
                            <input
                              className="input"
                              type="email"
                              style={{
                        				color: "#061B2B",
                        				fontWeight: "bold",
                        				fontSize: "14px",
                        				textAlign: "left",
                        				border: "1px solid #EBEBED",
                        				borderRadius: "4px",
                        				width: "90%",
                        				height: "35px",
                        				paddingLeft: "10px",
                                backgroundColor: "#EBEBED"
                              }}
                              onKeyPress={(e) => this.enterEvent(e, this)}
                              onChange={(e) => this.maskDoc(e, this)}
                              value={this.state.doc}></input>
                            <div
                              style={{
                                width: "100%",
                        				maxWidth: "290px",
                        				backgroundColor: "#54E046",
                        				color: "#fff",
                        				borderRadius: "6px",
                        				border: "2px solid #54E046",
                        				height: "50px",
                        				fontWeight: "bolder",
                        				cursor: "pointer",
                        				paddingTop: "10px",
                        				marginTop: "20px",
                        				textAlign: "center",
                              }}
                              className="btnLogin"
                              onClick={() => {this.sendResetByEmail();}}
                              >
                                Enviar código de redefinição
                              </div>
                          </div>
                        </div>
                      }
                      {
                        this.state.step === 2 &&
                        <div style={{width: "100%", maxWidth: "300px", display: "block", margin: "10px auto"}}>
                          <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                            <b style={{fontSize: "20px"}}>Olá, {this.state.userName}!<br/></b>
                            Digite o código de redefinição enviado no seu email
                          </div>
                          <div className="mt-2">

                            <input
                              className="input"
                              type="email"
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "90%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED"
                              }}
                              onKeyPress={(e) => this.enterEvent(e, this)}
                              onChange={(e) => this.maskDoc(e, this)}
                              value={this.state.doc}></input>

                            <div
                              style={{
                                width: "100%",
                        				maxWidth: "290px",
                        				backgroundColor: "#54E046",
                        				color: "#fff",
                        				borderRadius: "6px",
                        				border: "2px solid #54E046",
                        				height: "50px",
                        				fontWeight: "bolder",
                        				cursor: "pointer",
                        				paddingTop: "10px",
                        				marginTop: "20px",
                        				textAlign: "center",
                              }}
                              className="btnLogin"
                              onClick={() => {this.sendResetByCode();}}
                              >
                              Redefinir senha
                            </div><br/>

                            <p style={{fontSize: "13px"}}><b>
                              Não recebeu?&nbsp;&nbsp;
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: "#54E046",
                                  cursor: "pointer"
                                }}
                                onClick={() => {this.sendResetByEmail();}}
                                >
                                Enviar novamente
                              </span> em 00:{this.formatTime(this.state.time)} segundos

                            </b></p>
                          </div>
                        </div>
                      }
                      {
                        this.state.step === 3 &&
                        <div style={{width: "100%", maxWidth: "300px", display: "block", margin: "10px auto"}}>
                          <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                            <b style={{fontSize: "20px"}}>Redefina sua senha</b>
                          </div>

                          <div className="mt-2">
                            <div
                              style={{
                                backgroundColor: "#E2ECFB",
                                borderRadius: "8px",
                                fontSize: "12px",
                                color: "#236AD5",
                                padding: "10px"
                              }}
                            >
                              Para a sua segurança, nós recomendamos que a senha consista de pelo menos 8 caracteres, incluindo caracteres especiais (@, + , etc.), letras maiúsculas, minúsculas e números.
                            </div><br/>

                            <div className="label" style={{fontSize: "14px", position: "relative", marginBottom: "5px"}}>
                              Digite sua nova senha
                              <div className="contentStrongPassword" style={{
                            		position: "absolute",
                            		top: "-10px",
                            		right: "0px"
                              }}>
                                <p id="labelStatusStrongPassword" style={{
                                  textAlign: "right",
                                	fontWeight: "bold"
                                }}>Fraca</p>
                                <div className="contentStatusStrongPassword" style={{
                                  width: "100px",
                                	position: "relative",
                                	height: "5px",
                                	backgroundColor: "#EBEBED",
                                	borderRadius: "8px",
                                	overflow: "hidden"
                                }}>
                                  <div id="statusStrongPassword" style={{
                                    position: "absolute",
                                  	left: "0px",
                                  	top: "0px",
                                  	backgroundColor: "red",
                                  	width: "10%",
                                  	height: "5px",
                                  	borderRadius: "8px"
                                  }}></div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                position: "absolute",
                        				right: "115px",
                        				top: "231px"
                              }}>
                              {
                                this.state.enableViewRedefinePassword &&
                                <img
                                  src={require("../../assets/imgs/open-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                                />
                              }
                              {
                                !this.state.enableViewRedefinePassword &&
                                <img
                                  src={require("../../assets/imgs/close-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer",
                                    border: "2px solid rgba(0,0,0,0)",
                                    position: "relative",
                                    top: "2px"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefinePassword: !this.state.enableViewRedefinePassword})}}
                                />
                              }
                            </div>
                            <input
                              className="input"
                              type={(this.state.enableViewRedefinePassword?'text':'password')}
                              onKeyPress={(e) => this.enterEvent(e, this)}
                              onChange={(e) => this.maskRedefinePassword(e, this)}
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "100%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED"
                              }}
                              value={this.state.redefinePassword}></input>
                            <br/><br/>
                            <p className="label" style={{fontSize: "14px", position: "relative", marginBottom: "5px"}}>Redigite sua nova senha</p>
                            <div
                              style={{
                                position: "absolute",
                        				right: "115px",
                        				top: "317px"
                              }}>
                              {
                                this.state.enableViewRedefineRetypePassword &&
                                <img
                                  src={require("../../assets/imgs/open-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefineRetypePassword: !this.state.enableViewRedefineRetypePassword})}} />
                              }
                              {
                                !this.state.enableViewRedefineRetypePassword &&
                                <img
                                  src={require("../../assets/imgs/close-eye.svg").default}
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer",
                                    border: "2px solid rgba(0,0,0,0)",
                                    position: "relative",
                                    top: "2px"
                                  }}
                                  onClick={() => {this.setState({enableViewRedefineRetypePassword: !this.state.enableViewRedefineRetypePassword})}} />
                              }
                            </div>
                            <input
                              className="input"
                              type={(this.state.enableViewRedefineRetypePassword?'text':'password')}
                              onKeyPress={(e) => this.enterEvent(e, this)}
                              onChange={(e) => this.maskRedefineRetypePassword(e, this)}
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "100%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED"
                              }}
                              value={this.state.redefineRetypePassword}></input>
                            <br/>
                            <div
                              style={{
                                width: "100%",
                        				maxWidth: "290px",
                        				backgroundColor: "#54E046",
                        				color: "#fff",
                        				borderRadius: "6px",
                        				border: "2px solid #54E046",
                        				height: "50px",
                        				fontWeight: "bolder",
                        				cursor: "pointer",
                        				paddingTop: "10px",
                        				marginTop: "20px",
                        				textAlign: "center",
                              }}
                              className="btnLogin"
                              onClick={() => {this.redefinePassword();}}
                              >
                              Redefinir senha
                            </div>
                          </div>
                        </div>
                      }
                      {
                        this.state.step === 4 &&
                        <div style={{width: "100%", maxWidth: "330px", display: "block", margin: "10px auto"}}>
                          <div style={{fontSize: "16px", textAlign: "left", marginBottom: "15px"}}>
                            <b style={{fontSize: "20px", marginBottom: "25px"}}>
                              <img
                                src={require("../../assets/imgs/check-clear.svg").default}
                                alt="Icone check"
                                className="iconPasswordInput"
                                style={{
                                  display: "inline-block",
                                  marginRight: "5px",
                                  position: "relative",
                                  top: "-3px"
                                }}
                                />
                              Senha redefinida com sucesso.
                            <br/></b>
                            {this.state.userName}, agora você pode fechar esse diálogo e acessar sua conta.
                          </div>
                          <div className="mt-2">
                            <div
                              style={{
                                width: "100%",
                        				maxWidth: "290px",
                        				backgroundColor: "#54E046",
                        				color: "#fff",
                        				borderRadius: "6px",
                        				border: "2px solid #54E046",
                        				height: "50px",
                        				fontWeight: "bolder",
                        				cursor: "pointer",
                        				paddingTop: "10px",
                        				marginTop: "20px",
                        				textAlign: "center",
                              }}
                              onClick={() => this.setOpen(this, false)}>
                              Ir
                            </div>
                          </div>
                        </div>
                      }
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        }
        {
            // <ToastContainer />
        }
      </section>
    );
  }
}

export default withRouter(Item);
